(() => {
let headerObserver;
function fitOpening() {
if (headerObserver) headerObserver.disconnect();
const headerParts = [...document.querySelectorAll('.av-announcement, .av-header, .av-category-nav')];
const updateHeight = () => {
const height = headerParts.reduce((total, part) => total + part.getBoundingClientRect().height, 0);
document.documentElement.style.setProperty('--av-header-height', `${height}px`);
};
updateHeight();
if ('ResizeObserver' in window) {
headerObserver = new ResizeObserver(updateHeight);
headerParts.forEach(part => headerObserver.observe(part));
}
}
function init(scope = document) {
fitOpening();
scope.querySelectorAll('.av-mobile-menu').forEach(menu => {
if (menu.dataset.ready) return;
menu.dataset.ready = 'true';
menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
});
scope.querySelectorAll('[data-av-catalog]').forEach(catalog => {
if (catalog.dataset.ready) return;
catalog.dataset.ready = 'true';
const grid = catalog.querySelector('[data-av-grid]');
const cards = [...grid.querySelectorAll('[data-av-card]')];
const search = catalog.querySelector('[data-av-search]');
const sort = catalog.querySelector('[data-av-sort]');
const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
function update() {
const groups = {};
catalog.querySelectorAll('[data-av-filter]:checked').forEach(input => (groups[input.dataset.avFilter] ||= []).push(input.value));
const term = normalize(search.value.trim());
let count = 0;
cards.forEach(card => {
card.hidden = !normalize(card.dataset.search || card.dataset.name).includes(term) || Object.entries(groups).some(([key, values]) => !values.includes(card.dataset[key]));
if (!card.hidden) count++;
});
const ordered = [...cards];
if (sort.value === 'az') ordered.sort((a,b) => a.dataset.name.localeCompare(b.dataset.name, 'pt-BR'));
if (sort.value === 'za') ordered.sort((a,b) => b.dataset.name.localeCompare(a.dataset.name, 'pt-BR'));
if (sort.value === 'new') ordered.sort((a,b) => Number(b.dataset.created) - Number(a.dataset.created));
ordered.forEach(card => grid.append(card));
catalog.querySelector('[data-av-count]').textContent = count;
catalog.querySelector('[data-av-empty]').hidden = count !== 0;
}
catalog.addEventListener('change', update);
search.addEventListener('input', update);
catalog.querySelector('[data-av-reset]').addEventListener('click', () => {
catalog.querySelectorAll('[data-av-filter]').forEach(input => input.checked = false);
search.value = '';
sort.value = 'featured';
update();
});
if (window.matchMedia('(max-width:700px)').matches) catalog.querySelector('details').open = false;
update();
});
}
document.addEventListener('DOMContentLoaded', () => init());
document.addEventListener('shopify:section:load', event => init(event.target));
})();